import styled from 'styled-components';

export const SlideContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
`;
export const FormCard = styled.div`
  background: #fff;
  border-radius: 8px;
  padding: var(--sizes-90) var(--sizes-70);
  width: 50%;
  display: flex;
  justify-content: space-between;
`;
export const FormCardSummary = styled.div`
  width: 30%;
`;
export const FormCardFields = styled.div`
  display: flex;
  width: 65%;
  flex-direction: column;
  gap: var(--sizes-50);
`;

export const CampaignSetupContainer = styled.div`
  background: #fff;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  border-radius: 8px;
  padding: 24px 20px;
  width: 100%;
`;

export const CampaignSetupFields = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: var(--sizes-40);
`;

export const CampaignSetupRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: var(--sizes-50);
`;
